import { render, staticRenderFns } from "./Rejected.vue?vue&type=template&id=c665fb10&scoped=true"
import script from "./Rejected.vue?vue&type=script&lang=js"
export * from "./Rejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c665fb10",
  null
  
)

export default component.exports